import React from "react";
import { Dialog, Typography, CircularProgress, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useUpdateStatusDialogHook from "./UpdateStatusDialog.hook";
import styles from "./Style.module.css";
import { PrimaryButton } from "../../../../components/Buttons/PrimaryButton";
import CustomTextField from "../../../../components/FormFields/TextField/TextField.component";
import CustomSelectField from "../../../../components/FormFields/SelectField/SelectField.component";
import { useTheme } from "@emotion/react";

const UpdateStatusDialog = ({ isUpdateStatusOpen, handleUpdateStatus,  renderList }) => {
  const {
    changeTextData,
    onBlurHandler,
    status,
    form,
    errorData,
    isSubmitting,
    handleSubmit,
  } = useUpdateStatusDialogHook({
    isUpdateStatusOpen,
    handleUpdateStatus,
    renderList
  });
  const theme = useTheme();
  return (
    <div>
      <Dialog
        open={isUpdateStatusOpen}
        onClose={handleUpdateStatus}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "9px",
            width: "600px",
            maxWidth: "100%",
            margin: "auto",
          },
        }}
      >
        <div className={`${styles.dialogWrap} `}>
          <div className={styles.row}>
            <Typography variant="h4" sx={{ mb: 3 }} >
              {"Update Status"}
            </Typography>

            <CloseIcon onClick={handleUpdateStatus} />
          </div>

          <CustomSelectField
            isError={errorData?.status}
            AutoCompleteList={status ? status : []}
            label={"Choose Status"}
            sx={{ mb: 1 }}
            value={form?.status}
            handleChange={(value) => {
              changeTextData(value, "status");
            }}
          >
            <MenuItem value="PENDING">PENDING</MenuItem>
            <MenuItem value="IN_PROGRESS">IN PROGRESS</MenuItem>
            <MenuItem value="RESOLVED">RESOLVED</MenuItem>
            <MenuItem value="DISPOSED"> DISPOSED</MenuItem>
          </CustomSelectField>

          <CustomTextField
            multiline
            rows="5"
            sx={{ mt: 1, mb: 2 }}
            className={styles.desc}
            value={form?.comment}
            isError={errorData?.comment}
            errorText={errorData?.comment}
            onTextChange={(text) => {
              changeTextData(text, "comment");
            }}
            label={" Add Comments"}
            onBlur={() => {
              onBlurHandler("comment");
            }}
          />
          <Typography
            variant="subtitle1"
            className={`${styles.note} ${styles.buttonContainer}`}
          >
            Comment will be visible to end user also
          </Typography>
          <div >
            <div className={styles.saveButton}>
              <PrimaryButton
                color={"primary"}
                sx={{ mt: 2, mb: 2 }}
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color={"primary"} />
                ) : (
                  "CONFIRM & UPDATE"
                )}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UpdateStatusDialog;
